import {Ref, ref} from 'vue';
import {AxiosResponse} from "axios";

/**
 * Wraps a promise from an AxiosRequest, and assigns loading states, return values, and errors
 * @param promise
 */
export function useAwaitFetch<TResponse>(promise: Promise<AxiosResponse<TResponse>>): {
  data: Ref<TResponse>;
  error: Ref;
  loading: Ref<boolean>;
} {
  const data = ref(null);
  const error = ref(null);
  const loading = ref(false);

  loading.value = true;

  promise
    .then((response) => data.value = response.data)
    .catch((err) => (error.value = err))
    .finally(() => (loading.value = false));

  return { data, error, loading };
}
